import { ActionTypes } from '../../../constants';

export const selectAnalysisAxis = (analysisAxis: string) => {
  return {
    type: ActionTypes.SELECT_ANALYSIS_AXIS,
    data: analysisAxis,
  };
};
